import { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Simple in-memory cache so every landing page doesn't re-fetch /course-pricing separately
let pricingCache = null;
let pricingPromise = null;

const getPricing = () => {
  if (pricingCache) return Promise.resolve(pricingCache);
  if (!pricingPromise) {
    pricingPromise = axios.get(`${API_BASE}/api/course-pricing`)
      .then(({ data }) => { pricingCache = data.courses || []; return pricingCache; })
      .catch(() => []);
  }
  return pricingPromise;
};

/**
 * Shows "🇪🇸 Disponible en Español" on a course landing/signup page, but only
 * once that course actually has Spanish weeks uploaded (live-checked via /course-pricing).
 */
export const SpanishAvailableBadge = ({ slug, style = {} }) => {
  const [hasSpanish, setHasSpanish] = useState(false);

  useEffect(() => {
    let active = true;
    getPricing().then((courses) => {
      if (!active) return;
      const match = courses.find((c) => c.course_id === slug);
      setHasSpanish(!!match?.has_spanish);
    });
    return () => { active = false; };
  }, [slug]);

  if (!hasSpanish) return null;

  return (
    <span
      data-testid={`spanish-available-badge-${slug}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: '0.75rem',
        fontWeight: 700,
        background: 'rgba(196, 106, 83, 0.15)',
        color: '#C86A53',
        border: '1.5px solid #C86A53',
        borderRadius: '999px',
        padding: '0.2rem 0.7rem',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      🇪🇸 Disponible en Español
    </span>
  );
};

export default SpanishAvailableBadge;
